import {
	maxValueForAuroraPosFee,
	minValueForAuroraPosFee,
} from "validators/validation";

type CreateFeeItemProps = {
	feeLabel: string;
	feeName: string;
	calculationLabel: string;
	pricing_method: { label: string; value: number };
	isPricingMethodDisabled?: boolean;
	per_item_fee?: string;
	rate?: string;
	revenue_share?: string;
	type: number;
	disabled?: boolean;
	isRevenueShareDisabled?: boolean;
	perItemFeeValidate?: { [key: string]: any };
};

export const pricingMethods = {
	passThrough: { label: "Pass Through", value: 1 },
	absolute: { label: "Absolute", value: 2 },
	isoDiscretion: { label: "Iso Discretion", value: 5 },
};

export const scheduleAStatuses = [
	{ label: "Unavailable", value: 0 },
	{ label: "Available", value: 1 },
];

export const calculationTypes = {
	authorizationsThatWereThenCaptured:
		"Authorizations that were then Captured",
	basedOnMonthlyVolume: "Based on monthly volume",
	basedOnTransactionAuthorizationCount:
		"Based on transaction/ authorization count",
	callRequestToHoldFunds: "Call Request to hold funds",
	passThrough: "Pass Through",
	passThroughPerMidPerYear: "Pass through per MID per year",
	perAccountPerMonth: "Per account per month",
	perAruTransaction: "Per ARU transaction",
	perAuthorizationAttempt: "Per authorization attempt",
	perAvsAttempt: "Per AVS attempt",
	perCapture: "Per capture",
	perBatch: "Per batch",
	perDebitAuthorization: "Per debit authorization",
	perFedTaxId: "Per fed tax ID",
	perHelpDeskCall: "Per help desk call",
	perIncomeRetrieval: "Per income retrieval",
	perIncomingChargeback: "Per incoming chargeback",
	perMerchantPerMonth: "Per merchant per month",
	perMerchantPerWirelessTerminalPerMonth:
		"Per merchant per wireless terminal per month",
	perMerchantPerWirelessTerminalOnetimeFee:
		"Per merchant per wireless terminal onetime fee",
	perMicrosAuthorizationAttemptInclusiveOfDialOrIpAuthorizationCosts:
		"Per Micros authorization attempt, inclusive of dial or IP authorization costs",
	perMicrosCaptureInclusiveOfDialOrIpAuthorizationCosts:
		"Per Micros capture, inclusive of dial or IP authorization costs",
	perMidPerMonth: "Per MID per month",
	perMidPerYear: "Per MID per year",
	perNonCompliantMIdPerMonth: "Per non-compliant MID per month",
	perNonValidatedMidPerMonth: "Per non-validated MID per month",
	perPayeezyG4GatewayOneTimeFee: "Per Payeezy/G4 gateway one time fee",
	perPreAuthCompletion: "Per Pre Auth Completion",
	perStatementOrLetterSentPerMerchant:
		"Per statement or letter sent per merchant",
	perStatementPerMonth: "Per Statement Per Month",
	perTerminalPerDownload: "Per Terminal Per download",
	perTerminalPerMonthRiseFreeWithEquipmentWarranty:
		"Per terminal per month (Rise Free with equipment warranty)",
	perAchReject: "Per ACH reject",
	perSalonPerMonth: "Per Salon Per Month",
	perAppSubscriptionPerYear: "Per app subscription per year",
	perTerminatedMid: "Per Terminated MID",
	perUnitPerMonth: "Per unit per month",
	perUserPerMonth: "Per user per month",
	user1RevenueItem: "User 1 revenue item (without Schedule cost)",
	user2RevenueItem: "User 2 revenue item (without Schedule cost)",
	user3RevenueItem: "User 3 revenue item (without Schedule cost)",
	user4RevenueItem: "User 4 revenue item (without Schedule cost)",
	user5RevenueItem: "User 5 revenue item (without Schedule cost)",
	user6RevenueItem: "User 6 revenue item (without Schedule cost)",
	cardAccessFeeRevenue: "Card access fee revenue (Without Schedule cost)",
	basedOnMonthlyLoanPayments: "Based on monthly loan payments",
	basedOnMonthlyIPPayments: "Based on monthly IP payments",
};

export const fees = {
	binSponsorshipFee: "bin_sponsorship_fee",
	amexOptBlueFee: "amex_opt_blue_fee",
	interchangeFee: "interchange_fee",
	cardbrandDuesAndAssessmentsFee: "cardbrand_dues_and_assessments_fee",
	amexDuesAndAssessmentsFee: "amex_dues_and_assessments_fee",
	debitSwitchFee: "debit_switch_fee",
	debitNetworkFee: "debit_network_fee",
	dialAuthorizationFee: "dial_authorization_fee",
	cpuAuthorizationFee: "cpu_authorization_fee",
	ipAuthorizationFee: "ip_authorization_fee",
	salesTransactionFee: "sales_transaction_fee",
	voiceAuthorizationFee: "voice_authorization_fee",
	avsFee: "avs_fee",
	batchHeaderFee: "batch_header_fee",
	chargebackFee: "chargeback_fee",
	retrieval12bLetterFee: "retrieval_12b_letter_fee",
	pciMonthlyFee: "pci_monthly_fee",
	pciNonValidationFee: "pci_non_validation_fee",
	regulatoryProductFee: "regulatory_product_fee",
	annualFee: "annual_fee",
	riseFreeProgrammeFee: "rise_free_programme_fee",
	riseFreeProgrammeWithWarrantyFee: "rise_free_programme_with_warranty_fee",
	statementFee: "statement_fee",
	tinInvalidFee: "tin_invalid_fee",
	wirelessMonthlyServiceFee: "wireless_monthly_service_fee",
	wirelessSetUpAndActivationFee: "wireless_set_up_and_activation_fee",
	accountOnFileFee: "account_on_file_fee",
	aruFee: "aru_fee",
	wexDiscountFee: "wex_discount_fee",
	voyagerPerItemFee: "voyager_per_item_fee",
	voyagerRateFee: "voyager_rate_fee",
	postageFee: "postage_fee",
	earlyTerminationFee: "early_termination_fee",
	microsAuthorizationSurchargeFee: "micros_authorization_surcharge_fee",
	microsCaptureFee: "micros_capture_fee",
	portfolioManagerOrAccessOneFee: "portfolio_manager_or_access_one_fee",
	afterHourHelpDeskFee: "after_hour_help_desk_fee",
	tsysGuardianOrTokenizationMonthlyFee:
		"tsys_guardian_or_tokenization_monthly_fee",
	tsysGuardianOrTokenizationAuthorizationFee:
		"tsys_guardian_or_tokenization_authorization_fee",
	payeezyAuthorizationFee: "payeezy_authorization_fee",
	payeezyAvsFee: "payeezy_avs_fee",
	payeezyCaptureFee: "payeezy_capture_fee",
	payeezyOneTimeSetUpFee: "payeezy_one_time_set_up_fee",
	payeezyMonthlyFee: "payeezy_monthly_fee",
	cloverAndDataProtectionServiceFee: "clover_and_data_protection_service_fee",
	cloverGoFee: "clover_go_fee",
	cloverServicesFee: "clover_services_fee",
	cloverSecurityPlusFlatFee: "clover_security_plus_flat_fee",
	cloverTransarmorDataProtectionFlatFee:
		"clover_transarmor_data_protection_flat_fee",
	eidsDisputeToolFee: "eids_dispute_tool_fee",
	buypassDownloadAdjustmentsFee: "buypass_download_adjustments_fee",
	buypassPaperStatementFee: "buypass_paper_statement_fee",
	achRejectFee: "ach_reject_fee",
	ariseCommissionFee: "arise_commission_fee",
	pciAnnualFee: "pci_annual_fee",
	auroraPosFee: "aurora_pos_fee",
	marketingFee: "marketing_fee",
	loanFee: "loan_fee",
	instantPayoutFee: "instant_payout_fee",
	platformFee: "platform_fee",
	user1Rev: "user_1_rev",
	user2Rev: "user_2_rev",
	user3Rev: "user_3_rev",
	user4Rev: "user_4_rev",
	user5Rev: "user_5_rev",
	user6Rev: "user_6_rev",
};

const createFeeItem = ({
	feeLabel,
	feeName,
	calculationLabel,
	pricing_method,
	isPricingMethodDisabled,
	per_item_fee,
	rate,
	revenue_share,
	type,
	perItemFeeValidate,
	disabled,
	isRevenueShareDisabled,
}: CreateFeeItemProps) => ({
	feeLabel,
	feeName,
	calculationLabel,
	pricing_method,
	isPricingMethodDisabled: isPricingMethodDisabled ? true : false,
	per_item_fee: per_item_fee ? per_item_fee : "",
	rate: rate ? rate : "",
	revenue_share: revenue_share ? revenue_share : "",
	type,
	disabled: disabled ? true : false,
	isRevenueShareDisabled: isRevenueShareDisabled ? true : false,
	perItemFeeValidate: perItemFeeValidate || {},
});

export const feesModel = [
	createFeeItem({
		feeLabel: "BIN Sponsorship Fee",
		feeName: fees.binSponsorshipFee,
		calculationLabel: calculationTypes.basedOnMonthlyVolume,
		pricing_method: pricingMethods.absolute,
		type: 1,
	}),
	createFeeItem({
		feeLabel: "Platform Fee",
		feeName: fees.platformFee,
		calculationLabel: calculationTypes.basedOnMonthlyVolume,
		pricing_method: pricingMethods.absolute,
		type: 74,
	}),
	createFeeItem({
		feeLabel: "Amex Opt Blue Fee",
		feeName: fees.amexOptBlueFee,
		calculationLabel: calculationTypes.basedOnMonthlyVolume,
		pricing_method: pricingMethods.absolute,
		type: 2,
	}),
	createFeeItem({
		feeLabel: "Interchange Fee",
		feeName: fees.interchangeFee,
		calculationLabel: calculationTypes.passThrough,
		pricing_method: pricingMethods.passThrough,
		type: 3,
	}),
	createFeeItem({
		feeLabel: "Cardbrand Dues & Assessments Fee",
		feeName: fees.cardbrandDuesAndAssessmentsFee,
		calculationLabel: calculationTypes.passThrough,
		pricing_method: pricingMethods.passThrough,
		type: 4,
	}),
	createFeeItem({
		feeLabel: "Debit Switch Fee",
		feeName: fees.debitSwitchFee,
		calculationLabel: calculationTypes.perDebitAuthorization,
		pricing_method: pricingMethods.absolute,
		type: 6,
	}),
	createFeeItem({
		feeLabel: "Debit Network Fee",
		feeName: fees.debitNetworkFee,
		calculationLabel: calculationTypes.passThrough,
		pricing_method: pricingMethods.passThrough,
		type: 7,
	}),
	createFeeItem({
		feeLabel: "Dial Authorization Fee",
		feeName: fees.dialAuthorizationFee,
		calculationLabel: calculationTypes.perAuthorizationAttempt,
		pricing_method: pricingMethods.absolute,
		type: 8,
		isRevenueShareDisabled: true,
	}),
	createFeeItem({
		feeLabel: "CPU Authorization Fee",
		feeName: fees.cpuAuthorizationFee,
		calculationLabel: calculationTypes.perAuthorizationAttempt,
		pricing_method: pricingMethods.absolute,
		type: 9,
		isRevenueShareDisabled: true,
	}),
	createFeeItem({
		feeLabel: "IP Authorization Fee",
		feeName: fees.ipAuthorizationFee,
		calculationLabel: calculationTypes.perAuthorizationAttempt,
		pricing_method: pricingMethods.absolute,
		type: 10,
		isRevenueShareDisabled: true,
	}),
	createFeeItem({
		feeLabel: "Sales Transaction Fee",
		feeName: fees.salesTransactionFee,
		calculationLabel: calculationTypes.authorizationsThatWereThenCaptured,
		pricing_method: pricingMethods.absolute,
		type: 11,
	}),
	createFeeItem({
		feeLabel: "Voice Authorization Fee",
		feeName: fees.voiceAuthorizationFee,
		calculationLabel: calculationTypes.callRequestToHoldFunds,
		pricing_method: pricingMethods.absolute,
		type: 12,
	}),
	createFeeItem({
		feeLabel: "AVS Fee",
		feeName: fees.avsFee,
		calculationLabel: calculationTypes.perAvsAttempt,
		pricing_method: pricingMethods.absolute,
		type: 13,
	}),
	createFeeItem({
		feeLabel: "Batch Header Fee",
		feeName: fees.batchHeaderFee,
		calculationLabel: calculationTypes.perBatch,
		pricing_method: pricingMethods.absolute,
		type: 14,
	}),
	createFeeItem({
		feeLabel: "Chargeback Fee",
		feeName: fees.chargebackFee,
		calculationLabel: calculationTypes.perIncomingChargeback,
		pricing_method: pricingMethods.absolute,
		type: 15,
	}),
	createFeeItem({
		feeLabel: "Retrieval (12B Letter) Fee",
		feeName: fees.retrieval12bLetterFee,
		calculationLabel: calculationTypes.perIncomeRetrieval,
		pricing_method: pricingMethods.absolute,
		type: 16,
	}),
	createFeeItem({
		feeLabel: "Statement Fee",
		feeName: fees.statementFee,
		calculationLabel: calculationTypes.perMerchantPerMonth,
		pricing_method: pricingMethods.absolute,
		per_item_fee: "",
		rate: "",
		revenue_share: "",
		type: 23,
	}),
	createFeeItem({
		feeLabel: "Portfolio Manager / Access One Fee",
		feeName: fees.portfolioManagerOrAccessOneFee,
		calculationLabel: calculationTypes.perUserPerMonth,
		pricing_method: pricingMethods.absolute,
		type: 35,
	}),
	createFeeItem({
		feeLabel: "PCI Monthly Fee",
		feeName: fees.pciMonthlyFee,
		calculationLabel: calculationTypes.perMidPerMonth,
		pricing_method: pricingMethods.absolute,
		type: 17,
	}),
	createFeeItem({
		feeLabel: "PCI Non-Validation Fee",
		feeName: fees.pciNonValidationFee,
		calculationLabel: calculationTypes.perNonValidatedMidPerMonth,
		pricing_method: pricingMethods.absolute,
		type: 18,
	}),
	createFeeItem({
		feeLabel: "Regulatory Product Fee",
		feeName: fees.regulatoryProductFee,
		calculationLabel: calculationTypes.perFedTaxId,
		pricing_method: pricingMethods.absolute,
		type: 19,
	}),
	createFeeItem({
		feeLabel: "Annual Fee",
		feeName: fees.annualFee,
		calculationLabel: calculationTypes.passThroughPerMidPerYear,
		pricing_method: pricingMethods.passThrough,
		type: 20,
	}),
	createFeeItem({
		feeLabel: "TIN Invalid Fee",
		feeName: fees.tinInvalidFee,
		calculationLabel: calculationTypes.perNonCompliantMIdPerMonth,
		pricing_method: pricingMethods.absolute,
		type: 24,
	}),
	createFeeItem({
		feeLabel: "Wireless Monthly Service Fee",
		feeName: fees.wirelessMonthlyServiceFee,
		calculationLabel:
			calculationTypes.perMerchantPerWirelessTerminalPerMonth,
		pricing_method: pricingMethods.passThrough,
		type: 25,
	}),
	createFeeItem({
		feeLabel: "Wireless Set up & Activation Fee",
		feeName: fees.wirelessSetUpAndActivationFee,
		calculationLabel:
			calculationTypes.perMerchantPerWirelessTerminalOnetimeFee,
		pricing_method: pricingMethods.passThrough,
		type: 26,
	}),
	createFeeItem({
		feeLabel: "Account on File Fee",
		feeName: fees.accountOnFileFee,
		calculationLabel: calculationTypes.perMerchantPerMonth,
		pricing_method: pricingMethods.absolute,
		type: 27,
	}),
	createFeeItem({
		feeLabel: "ARU Fee",
		feeName: fees.aruFee,
		calculationLabel: calculationTypes.perAruTransaction,
		pricing_method: pricingMethods.absolute,
		type: 28,
	}),
	createFeeItem({
		feeLabel: "Wex Discount fee",
		feeName: fees.wexDiscountFee,
		calculationLabel: calculationTypes.basedOnMonthlyVolume,
		pricing_method: pricingMethods.absolute,
		type: 53,
	}),
	createFeeItem({
		feeLabel: "Voyager Rate Fee",
		feeName: fees.voyagerRateFee,
		calculationLabel: calculationTypes.basedOnMonthlyVolume,
		pricing_method: pricingMethods.absolute,
		type: 31,
	}),
	createFeeItem({
		feeLabel: "Voyager Per-item Fee",
		feeName: fees.voyagerPerItemFee,
		calculationLabel: calculationTypes.basedOnTransactionAuthorizationCount,
		pricing_method: pricingMethods.absolute,
		type: 30,
	}),
	createFeeItem({
		feeLabel: "Postage Fee",
		feeName: fees.postageFee,
		calculationLabel: calculationTypes.perStatementOrLetterSentPerMerchant,
		pricing_method: pricingMethods.absolute,
		type: 32,
	}),
	createFeeItem({
		feeLabel: "Early Termination Fee",
		feeName: fees.earlyTerminationFee,
		calculationLabel: calculationTypes.perTerminatedMid,
		pricing_method: pricingMethods.passThrough,
		type: 33,
	}),
	createFeeItem({
		feeLabel: "Micros Authorization Surcharge Fee",
		feeName: fees.microsAuthorizationSurchargeFee,
		calculationLabel:
			calculationTypes.perMicrosAuthorizationAttemptInclusiveOfDialOrIpAuthorizationCosts,
		pricing_method: pricingMethods.absolute,
		type: 34,
	}),
	createFeeItem({
		feeLabel: "Micros Capture Fee",
		feeName: fees.microsCaptureFee,
		calculationLabel:
			calculationTypes.perMicrosCaptureInclusiveOfDialOrIpAuthorizationCosts,
		pricing_method: pricingMethods.absolute,
		type: 54,
	}),
	createFeeItem({
		feeLabel: "After Hour Help Desk Fee",
		feeName: fees.afterHourHelpDeskFee,
		calculationLabel: calculationTypes.perHelpDeskCall,
		pricing_method: pricingMethods.absolute,
		type: 36,
	}),
	createFeeItem({
		feeLabel: "TSYS Guardian/ Tokenization Monthly Fee",
		feeName: fees.tsysGuardianOrTokenizationMonthlyFee,
		calculationLabel: calculationTypes.perMerchantPerMonth,
		pricing_method: pricingMethods.absolute,
		type: 37,
	}),
	createFeeItem({
		feeLabel: "TSYS Guardian/ Tokenization Authorization Fee",
		feeName: fees.tsysGuardianOrTokenizationAuthorizationFee,
		calculationLabel: calculationTypes.perAuthorizationAttempt,
		pricing_method: pricingMethods.absolute,
		type: 38,
	}),
	createFeeItem({
		feeLabel: "Payeezy Authorization Fee",
		feeName: fees.payeezyAuthorizationFee,
		calculationLabel: calculationTypes.perAuthorizationAttempt,
		pricing_method: pricingMethods.passThrough,
		type: 39,
	}),
	createFeeItem({
		feeLabel: "Payeezy AVS Fee",
		feeName: fees.payeezyAvsFee,
		calculationLabel: calculationTypes.perAvsAttempt,
		pricing_method: pricingMethods.passThrough,
		type: 40,
	}),
	createFeeItem({
		feeLabel: "Payeezy Capture Fee",
		feeName: fees.payeezyCaptureFee,
		calculationLabel: calculationTypes.perCapture,
		pricing_method: pricingMethods.passThrough,
		type: 55,
	}),
	createFeeItem({
		feeLabel: "Payeezy One Time Set Up Fee",
		feeName: fees.payeezyOneTimeSetUpFee,
		calculationLabel: calculationTypes.perPayeezyG4GatewayOneTimeFee,
		pricing_method: pricingMethods.passThrough,
		type: 41,
	}),
	createFeeItem({
		feeLabel: "Payeezy Monthly Fee",
		feeName: fees.payeezyMonthlyFee,
		calculationLabel: calculationTypes.perMidPerMonth,
		pricing_method: pricingMethods.passThrough,
		type: 42,
	}),
	createFeeItem({
		feeLabel: "Clover & Data Protection Service Fee",
		feeName: fees.cloverAndDataProtectionServiceFee,
		calculationLabel: calculationTypes.perMidPerMonth,
		pricing_method: pricingMethods.passThrough,
		type: 43,
	}),
	createFeeItem({
		feeLabel: "Clover Go Fee",
		feeName: fees.cloverGoFee,
		calculationLabel: calculationTypes.perUnitPerMonth,
		pricing_method: pricingMethods.passThrough,
		type: 44,
	}),
	createFeeItem({
		feeLabel: "Clover Services Fee",
		feeName: fees.cloverServicesFee,
		calculationLabel: calculationTypes.perUnitPerMonth,
		pricing_method: pricingMethods.passThrough,
		type: 45,
	}),
	createFeeItem({
		feeLabel: "Clover Security Plus Flat Fee",
		feeName: fees.cloverSecurityPlusFlatFee,
		calculationLabel: calculationTypes.perMidPerMonth,
		pricing_method: pricingMethods.passThrough,
		type: 46,
	}),
	createFeeItem({
		feeLabel: "Clover Transarmor Data Protection Flat Fee",
		feeName: fees.cloverTransarmorDataProtectionFlatFee,
		calculationLabel: calculationTypes.perMidPerMonth,
		pricing_method: pricingMethods.absolute,
		type: 47,
	}),
	createFeeItem({
		feeLabel: "eIDS Dispute Tool Fee",
		feeName: fees.eidsDisputeToolFee,
		calculationLabel: calculationTypes.perAccountPerMonth,
		pricing_method: pricingMethods.absolute,
		type: 49,
	}),
	createFeeItem({
		feeLabel: "Rise Free Programme Fee",
		feeName: fees.riseFreeProgrammeFee,
		calculationLabel: calculationTypes.perMerchantPerMonth,
		pricing_method: pricingMethods.absolute,
		type: 21,
		isRevenueShareDisabled: true,
	}),
	createFeeItem({
		feeLabel: "Rise Free Programme w/ Warranty Fee",
		feeName: fees.riseFreeProgrammeWithWarrantyFee,
		calculationLabel:
			calculationTypes.perTerminalPerMonthRiseFreeWithEquipmentWarranty,
		pricing_method: pricingMethods.absolute,
		type: 22,
		isRevenueShareDisabled: true,
	}),
	createFeeItem({
		feeLabel: "ACH Reject Fee",
		feeName: fees.achRejectFee,
		calculationLabel: calculationTypes.perAchReject,
		pricing_method: pricingMethods.absolute,
		type: 63,
	}),
	createFeeItem({
		feeLabel: "ARISE Commission Fee",
		feeName: fees.ariseCommissionFee,
		calculationLabel: calculationTypes.perMerchantPerMonth,
		pricing_method: pricingMethods.passThrough,
		type: 71,
	}),
	createFeeItem({
		feeLabel: "PCI Annual Fee",
		feeName: fees.pciAnnualFee,
		calculationLabel: calculationTypes.perMidPerYear,
		pricing_method: pricingMethods.passThrough,
		isPricingMethodDisabled: true,
		type: 65,
	}),
	createFeeItem({
		feeLabel: "Aurora POS Fee",
		feeName: fees.auroraPosFee,
		calculationLabel: calculationTypes.perSalonPerMonth,
		pricing_method: pricingMethods.absolute,
		revenue_share: "50",
		type: 68,
		perItemFeeValidate: {
			maxValueForAuroraPosFee,
			minValueForAuroraPosFee,
		},
	}),
	createFeeItem({
		feeLabel: "Marketing Fee",
		feeName: fees.marketingFee,
		calculationLabel: calculationTypes.perSalonPerMonth,
		pricing_method: pricingMethods.absolute,
		revenue_share: "50",
		type: 70,
	}),
	createFeeItem({
		feeLabel: "Loan Fee",
		feeName: fees.loanFee,
		calculationLabel: calculationTypes.basedOnMonthlyLoanPayments,
		pricing_method: pricingMethods.absolute,
		type: 72,
	}),
	createFeeItem({
		feeLabel: "Instant Payout Fee",
		feeName: fees.instantPayoutFee,
		calculationLabel: calculationTypes.basedOnMonthlyIPPayments,
		pricing_method: pricingMethods.absolute,
		type: 73,
	}),
	createFeeItem({
		feeLabel: "User 1 Rev",
		feeName: fees.user1Rev,
		calculationLabel: calculationTypes.user1RevenueItem,
		pricing_method: pricingMethods.passThrough,
		type: 56,
	}),
	createFeeItem({
		feeLabel: "User 2 Rev",
		feeName: fees.user2Rev,
		calculationLabel: calculationTypes.user2RevenueItem,
		pricing_method: pricingMethods.passThrough,
		type: 57,
	}),
	createFeeItem({
		feeLabel: "User 3 Rev",
		feeName: fees.user3Rev,
		calculationLabel: calculationTypes.user3RevenueItem,
		pricing_method: pricingMethods.passThrough,
		type: 58,
	}),
	createFeeItem({
		feeLabel: "User 4 Rev",
		feeName: fees.user4Rev,
		calculationLabel: calculationTypes.user4RevenueItem,
		pricing_method: pricingMethods.passThrough,
		type: 59,
	}),
	createFeeItem({
		feeLabel: "User 5 Rev",
		feeName: fees.user5Rev,
		calculationLabel: calculationTypes.user5RevenueItem,
		pricing_method: pricingMethods.passThrough,
		type: 60,
	}),
	createFeeItem({
		feeLabel: "User 6 Rev",
		feeName: fees.user6Rev,
		calculationLabel: calculationTypes.user6RevenueItem,
		pricing_method: pricingMethods.passThrough,
		type: 61,
	}),
];

export const scheduleAFormDefaultValues = {
	status: { label: "Available", value: 1 },
	is_default: false,
	name: "",
	fees: feesModel,
	processor: null,
	are_fees_not_applicable: false,
	parent: {
		value: "",
		name: "Not assigned",
		status: "",
	},
};

export const feesExceptionsForAuroraAMS = [
	{
		feeName: fees.annualFee,
		revenue_share: "50",
	},
	{
		feeName: fees.earlyTerminationFee,
		revenue_share: "50",
	},
];
